import React from "react";

import { JSX } from "react/jsx-runtime";

const Unauthorized = React.memo(
  () //   {
  : JSX.Element => {
    return (
      <>
        <p>Not Found!</p>
      </>
    );
  }
);

export default React.memo(Unauthorized);
